import { useState } from 'react';
import { useAuth } from 'utils/contexts/auth-context';
import axios, { AxiosResponse } from 'axios';
import { getRequestBody, getSorensonEndpoint } from '../helpers';
import UserType from 'utils/constants/userType';
import { useMeetingStatus } from 'utils/contexts/meeting-status-context';
import { LANGUAGES } from 'utils/constants/languages';
import { STRINGS } from 'utils/constants';
interface IFormInput {
  link: string;
  phone: string;
  conferenceId: string;
  language?: string;
}

const useRequestInterpreter = () => {
  const { currentMeeting, interpreterRequest, setInterpreterRequest } =
    useMeetingStatus();
  const [loading, setLoading] = useState<boolean>(false);

  const { sorensonUser, userZoomData, ip, getTokenSilently, location } =
    useAuth();

  const submit = async (language?: string) => {
    try {
      setLoading(true);
      let billingId
      let billingName
      const apiKey = sorensonUser.userType === UserType.VRI ? process.env.REACT_APP_API_KEY_VRI : process.env.REACT_APP_API_KEY_VRS;

      if (sorensonUser.userType === UserType.VRI) {
        const token = await getTokenSilently()
        const { data } = await axios.post(`${process.env.REACT_APP_BILLING_API_BASE_URL}/GetUserBillingInformation`,
          { contact_email: sorensonUser.email },
          {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          }
        )

        billingId = data.BillingId
        billingName = data.BillingName
      }

      const { data } = await axios.post(
        `${getSorensonEndpoint(sorensonUser.userType)}zoom`,
        getRequestBody(
          currentMeeting?.joinUrl,
          sorensonUser,
          ip,
          currentMeeting?.userId,
          await getTokenSilently(),
          location || '',
          userZoomData.hearingPhoneNumber,
          language || LANGUAGES.ENGLISH,
          billingName,
          billingId
        ),
        {
          headers: {
            'x-api-key': apiKey as string,
            'Content-Type': 'application/json',
          },
        }
      );
      const success = data.callId !== '';
      setInterpreterRequest({
        loading: false,
        error: !success,
        inProcess: success,
        callId: data.callId,
      });
    } catch ({ response }: any) {
      const errorMessage =
        (response as AxiosResponse).data.message ===
          STRINGS.RELAY_RESPONSES.DUPLICATE_REQUEST
          ? STRINGS.ERROR_STRINGS.DUPLICATE_REQUEST
          : undefined;
      setInterpreterRequest({
        loading: false,
        error: true,
        inProcess: false,
        callId: interpreterRequest.callId,
        errorMessage,
      });
    } finally {
      setLoading(false);
    }
  };

  return { submit, loading };
};

export default useRequestInterpreter;

export type { IFormInput };
